<template>
    <ColorCategoryForm :color_category="color_category" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ColorCategoryForm from './ColorCategoryForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    ColorCategoryForm
  },
  data() {
    return {
      color_category:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.color_category=await APIRequest.detail('color-categories',this.$route.params.id)
    this.loaded=true
  }
}
</script>
